// observer.ts
type Callback = (...args: any[]) => void;

class Observer {
  private static instance: Observer;
  private events: { [key: string]: Callback[] } = {};

  private constructor() {}

  public static getInstance(): Observer {
    if (!Observer.instance) {
      Observer.instance = new Observer();
    }
    return Observer.instance;
  }

  public subscribe(event: string, callback: Callback): void {
    this.on(event, callback);
  }

  public publish(event: string, ...args: any[]): void {
    const callbacks = this.events[event];
    if (callbacks) {
      callbacks.forEach(callback => callback(...args));
    }
  }

  public on(event: string, callback: Callback): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event]!.push(callback);
  }

  public once(event: string, callback: Callback): void {
    const wrapper = (...args: any[]) => {
      callback(...args);
      this.off(event, wrapper);
    };
    this.on(event, wrapper);
  }

  public off(event: string, callback: Callback): void {
    if (this.events[event]) {
      this.events[event] = this.events[event]!.filter(cb => cb !== callback);
    }
  }
}

export const observer = Observer.getInstance();
